import React from 'react';
import { Route } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { PageFooter } from './footer';


class Both extends React.Component {

    componentDidMount() {
        AOS.init({
            duration: 400,
            anchor: '#app',
            placement: 'top-center',
            easing: 'ease-in-out',
            delay: 800,
        });
    }

    render() {
        console.log(this.props);
        return (
            <div className="MainContainer">
                <div className="HalfContainer">
                    <h1
                        data-aos="fade-up"
                        data-aos-delay="200"
                        className="Type-h1"
                    >
                        Meet the partners.
                    </h1>
                    <div data-aos="fade">
                        <div className="Partners">
                            <div className="Partner">
                                <img className="Partner-image u-mb-2" src={process.env.PUBLIC_URL + '/img/alex.jpg'} alt="Alex Mittal" />
                                <h2 className="Type-h2">
                                    Alex Mittal
                                </h2>
                                <p className="Type-body">
                                    <a className="Type-link" href="https://twitter.com/mittal" rel="noopener noreferrer" target="_blank">Twitter</a>&nbsp;&nbsp;
                                    <a className="Type-link" href="https://medium.com/@mittal" rel="noopener noreferrer" target="_blank">Medium</a>&nbsp;&nbsp;
                                    <a className="Type-link" href="https://www.linkedin.com/in/alexandermittal" rel="noopener noreferrer" target="_blank">LinkedIn</a>&nbsp;&nbsp;
                                    <a className="Type-link" href="mailto:alex@fundersclub.com" rel="noopener noreferrer" target="_blank">Email</a>&nbsp;&nbsp;
                                </p>
                                <p className="Type-body">
                                    Former founder of venture backed startups in hardware (acquired) and enterprise data, Y Combinator alumnus, graduate of Wharton and UPenn (economics & engineering degrees, Penn M&T).
                                </p>
                                <p className="Type-body">
                                    <strong>Featured Companies</strong><br/>
                                    Coinbase, Instacart, Webflow, Gecko Robotics, Solugen, Zum, Caper AI, Shippo, UpKeep, Cleartax, Embark Trucks, Verse Medical, Embrace, Bego AI, Riot Security, Lexica, Arpeggio Bio, Momence, Inversion Space, Ontop, Toku, SimpleHash
                                </p>
                            </div>
                            <div className="Partner">
                                <img className="Partner-image u-mb-2" src={process.env.PUBLIC_URL + '/img/boris.jpg'} alt="Boris Silver" />
                                <h2 className="Type-h2">
                                    Boris Silver
                                </h2>
                                <p className="Type-body">
                                    <a className="Type-link" href="https://twitter.com/borismsilver" rel="noopener noreferrer" target="_blank">Twitter</a>&nbsp;&nbsp;
                                    <a className="Type-link" href="https://medium.com/@borismsilver" rel="noopener noreferrer" target="_blank">Medium</a>&nbsp;&nbsp;
                                    <a className="Type-link" href="https://www.linkedin.com/in/borismsilver" rel="noopener noreferrer" target="_blank">LinkedIn</a>&nbsp;&nbsp;
                                    <a className="Type-link" href="mailto:boris@fundersclub.com" rel="noopener noreferrer" target="_blank">Email</a>&nbsp;&nbsp;
                                </p>
                                <p className="Type-body">
                                    Former founder of a fantasy sports gaming company (acquired), Y Combinator alumnus, graduated Summa Cum Laude with a Bachelor of Science in Economics from The Wharton School at the University of Pennsylvania.
                                </p>
                                <p className="Type-body">
                                    <strong>Featured Companies</strong><br/>
                                    Instacart, Coinbase, GitLab, Flexport, Rappi, Zūm, ShipBob, AppZen, Wonderschool, Unbabel, Platzi, Aircall, Second Measure, EquipmentShare, Scentbird, Lob, Castle, Zentail, SendBird, Pipefy, HomeLight
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <PageFooter/>
            </div>
        );
    }
}

class Partners extends React.Component {
    render() {
        console.log(this.props);
        return (
            <div>
                <Route exact path="/partners" component={Both} />
            </div>
        );
    };
};

export default Partners;



// WEBPACK FOOTER //
// ./src/components/partners.js